import { render } from "./TournamentResultModal.vue?vue&type=template&id=f82698e4&scoped=true"
import script from "./TournamentResultModal.vue?vue&type=script&lang=js"
export * from "./TournamentResultModal.vue?vue&type=script&lang=js"

import "./TournamentResultModal.vue?vue&type=style&index=0&id=f82698e4&scoped=true&lang=css"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f82698e4"]])

export default __exports__